export default class DtoQualityIndicator {
    constructor(obj) {
        this.id = obj.id
        this.threshold = obj.threshold
    }
}